import { Cluster } from '@googlemaps/markerclusterer';

export const clustersRenderer = (color: 'ANIS' | 'PURPLE') => ({
  render: ({ count, position }: Cluster) => {
    const div = document.createElement('div');
    div.style.display = 'flex';
    div.style.width = '45px';
    div.style.height = '45px';
    div.style.padding = '8px 15px';
    div.style.flexDirection = 'column';
    div.style.justifyContent = 'center';
    div.style.alignItems = 'center';
    div.style.gap = '10px';
    div.style.flexShrink = '0';
    div.style.borderRadius = '14px';
    div.style.background = color === 'ANIS' ? '#D4D600' : '#C7A0FB';
    div.style.boxShadow = '2px 2px 0px 0px #000';

    const text = document.createElement('span');
    text.textContent = String(count);
    text.style.color = '#000';
    text.style.textAlign = 'center';
    text.style.fontFamily = 'Caprasimo';
    text.style.fontSize = '24px';
    text.style.fontStyle = 'normal';
    text.style.fontWeight = '400';
    text.style.lineHeight = 'normal';

    div.appendChild(text);

    return new google.maps.marker.AdvancedMarkerElement({
      position,
      content: div,
    });
  },
});
